var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.analysPieBox},[_c('div',{class:_vm.$style.analysPie},[_c('PieChart',{attrs:{"chartData":_vm.option,"width":"2.2rem","height":"2.2rem"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }